import api from '../../../services/Api';
import { IAuditoriaAdiantamentoSociosResultado } from '../interfaces/IAuditoriaAdiantamentoSocios';

export const AuditoriaAdiantamentoSociosService = {
  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
  }): Promise<IAuditoriaAdiantamentoSociosResultado> {
    const response = await api.get<IAuditoriaAdiantamentoSociosResultado>('auditoria-adiantamento-socios/resultado', {
      params: {
        empresaIds: params.empresaId,
        periodo: params.periodo || '',
      },
    });

    return (
      response.data || {
        impactoFiscalTotal: 0,
        impactoFinanceiroTotal: 0,
        totalAvisos: 0,
        totalAlertas: 0,
        totalErros: 0,
        status: 'CONCILIADO',
        mensagemDirecionamento: '',
        fundamentacaoCaracterizacaoRemuneracao: '',
        adiantamentosSemLastro: [],
        adiantamentosConciliados: [],
      }
    );
  },
};
